module.exports = __webpack_public_path__ + "assets/images/rbyearend-16.jpg?v=a1d3b579";